var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 890,
    height: 309,
    viewBox: "0 0 890 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M849.67 29L863.562 75.6127H826.131V280.015H769.018V75.6127H731.587L746.251 29H849.67Z",
    fill: "url(#paint0_linear_103_95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.342 32.1855C236.285 57.3748 240.219 79.0993 231.195 104.826C222.705 129.031 206.746 150.609 188.969 170.374C166.222 195.664 139.576 218.954 106.995 233.238C74.4149 247.522 35.162 251.916 1.62305 239.534C18.5428 258.307 47.5763 266.035 74.382 263.526C101.189 261.02 126.016 249.539 147.977 235.559C184.393 212.375 214.817 181.704 236.22 146.599C247.623 127.899 256.619 107.403 256.899 86.1025C257.135 68.0634 249.205 40.7014 229.342 32.1855Z",
    fill: "url(#paint1_linear_103_95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.884 112.343C115.884 112.343 108.159 29.3945 212.455 29.3945C212.455 29.3945 142.924 62.2291 115.884 112.343Z",
    fill: "url(#paint2_linear_103_95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5704 127.898C96.5704 127.898 -30.9023 216.032 63.7356 79.5098C63.7356 79.5098 54.0784 124.441 96.5704 127.898Z",
    fill: "url(#paint3_radial_103_95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.679 122.712C121.679 122.712 245.288 29.3944 148.719 165.916C148.719 165.916 152.581 119.256 121.679 122.712Z",
    fill: "url(#paint4_radial_103_95)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5705 138.268C96.5705 138.268 112.022 216.033 0 221.216C0 221.216 88.8441 167.645 96.5705 138.268Z",
    fill: "url(#paint5_linear_103_95)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.755 131.325C108.815 133.062 106.089 133.441 104.668 132.167C103.248 130.896 103.669 128.458 105.61 126.721C107.55 124.986 110.276 124.609 111.697 125.879C113.118 127.151 112.696 129.59 110.755 131.325Z",
    fill: "url(#paint6_radial_103_95)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.95 209.235H353.805L341.07 119.807L327.95 209.235ZM321.776 248.942L316.759 280.015H260.42L310.972 29H370.784L421.336 280.015H364.996L359.979 248.942H321.776Z",
    fill: "url(#paint7_linear_103_95)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.771 29H541.734L551.382 75.6127H494.27V280.015H436.771V29Z",
    fill: "url(#paint8_linear_103_95)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.484 209.235H656.339L643.605 119.807L630.484 209.235ZM624.31 248.942L619.293 280.015H562.954L613.506 29H673.319L723.87 280.015H667.531L662.514 248.942H624.31Z",
    fill: "url(#paint9_linear_103_95)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_95",
    x1: 797.575,
    y1: 29,
    x2: 797.575,
    y2: 280.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#1C55C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_95",
    x1: 111.239,
    y1: 178.221,
    x2: 129.264,
    y2: 263.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171298,
    stopColor: "#1C55C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_95",
    x1: 116.239,
    y1: 122.721,
    x2: 185.239,
    y2: 71.2207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#1C55C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_103_95",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.2393 126.721) rotate(152.03) scale(82.0884 72.8668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#1C55C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_103_95",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.239 129.221) rotate(13.3925) scale(43.1741 37.1272)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#1C55C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_103_95",
    x1: 48.6464,
    y1: 138.268,
    x2: 48.6464,
    y2: 221.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#1C55C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_103_95",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.183 129.024) rotate(90) scale(3.89711 4.35558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#1C55C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_103_95",
    x1: 340.878,
    y1: 29,
    x2: 340.878,
    y2: 280.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#1C55C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_103_95",
    x1: 494.077,
    y1: 29,
    x2: 494.077,
    y2: 280.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#1C55C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A2E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_103_95",
    x1: 643.412,
    y1: 29,
    x2: 643.412,
    y2: 280.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#1C55C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A2E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.74c847adf4cd00ac561d8578105f2f90.svg";
export { ForwardRef as ReactComponent };